module.exports = __webpack_public_path__ + "18f16804d6c4445b2156a6d9c733beeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/docs/zip-compression/zip-compression-2.png
// module id = 2478
// module chunks = 0